import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useAppContext } from "../../../_context";
import RoleCard from "./RoleCard";

const OpenRoles = ({ jobSpecs }) => {
  const [{ tx }] = useAppContext();

  return (
    <section
      className={`roles-section section-padding-y ${
        jobSpecs.length ? "" : "d-none"
      }`}>
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <h3 className="header-title text-center">
              {tx["Current opportunities"]}
            </h3>
            <div>
              {jobSpecs.map((role, index) => (
                <RoleCard
                  key={index}
                  role={role}
                  last={index + 1 === jobSpecs.length}
                />
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default OpenRoles;
